import React, { useEffect, useState } from "react";
import banner1 from "../assets/img/Free medical camp 8-nov-2025/WhatsApp Image 2026-05-22 at 8.13.23 PM.jpeg"
import banner2 from "../assets/img/Free medical camp 29-nov-2025/WhatsApp Image 2026-05-22 at 8.14.34 PM.jpeg"
import about from "../assets/img/Free medical camp 41-3R 22-may-2026/WhatsApp Image 2026-05-22 at 8.29.42 PM.jpeg"
import ourWork1 from "../assets/img/Free medical camp 8-nov-2025/WhatsApp Image 2026-05-22 at 8.13.23 PM (1).jpeg"
import ourWork2 from "../assets/img/Education sitting 7-may-2026/WhatsApp Image 2026-05-22 at 8.25.41 PM.jpeg"
import ourWork3 from "../assets/img/Health awareness session 9-may-2026/WhatsApp Image 2026-05-22 at 8.29.21 PM.jpeg"
import knowledge from "../assets/img/Health awarness session 6-dec-2025/WhatsApp Image 2026-05-22 at 8.18.03 PM.jpeg"
import { Link } from "react-router-dom";
import Team from "./Team";
import { API_URL } from "../config/api";
import axios from "axios";


// import updates from "../assets/img/Free medical camp 29-nov-2025/WhatsApp Image 2026-05-22 at 8.14.37 PM (2).jpeg"


export const Home = () => {
    const [knowledgeCenters, setKnowledgeCenters] = useState([]);
    useEffect(() => {

    axios
        .get(`${API_URL}/api/knowledge-centers`)
        .then((response) => {

            setKnowledgeCenters(response.data);

        })
        .catch((error) => {

            console.log(error);

        });

}, []);
    return(
        <div>
                    {/* <!-- Carousel Start --> */}
        <div class="container-fluid carousel px-0 mb-5 pb-5">
            <div id="carouselId" class="carousel slide" data-bs-ride="carousel">
                <ol class="carousel-indicators">
                    <li data-bs-target="#carouselId" data-bs-slide-to="0" class="active" aria-current="true" aria-label="First slide"></li>
                    <li data-bs-target="#carouselId" data-bs-slide-to="1" aria-label="Second slide"></li>
                </ol>
                <div class="carousel-inner" role="listbox">
                    <div class="carousel-item active">
                        <img src={banner1} class="img-fluid w-100" alt="First slide" />
                        <div class="carousel-caption">
                            <div class="container carousel-content">
                                <h4 class="text-white mb-4 animated slideInDown">Together We Can Make a Difference</h4>
                                <h1 class="text-white display-1 mb-4 animated slideInDown">Creating Brighter Futures for Those in Need</h1>
                                {/* <a href="" class="me-2"><button type="button" class="px-5 py-3 btn btn-primary border-2 rounded-pill animated slideInDown">Read More</button></a> */}
                            </div>
                        </div>
                    </div>
                    <div class="carousel-item">
                        <img src={banner2}  class="img-fluid w-100" alt="Second slide" />
                        <div class="carousel-caption">
                            <div class="container carousel-content">
                                <h4 class="text-white mb-4 animated slideInDown">Every Helping Hand Matters</h4>
                                <h1 class="text-white display-1 mb-4 animated slideInDown">Empowering Communities Through Care & Support</h1>
                                {/* <a href="" class="me-2"><button type="button" class="px-5 py-3 btn btn-primary border-2 rounded-pill animated slideInDown">Read More</button></a> */}
                            </div>
                        </div>
                    </div>
                </div>
                {/* <button class="carousel-control-prev btn btn-primary border border-2 border-start-0 border-primary" type="button" data-bs-target="#carouselId" data-bs-slide="prev">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Previous</span>
                </button>
                <button class="carousel-control-next btn btn-primary border border-2 border-end-0 border-primary" type="button" data-bs-target="#carouselId" data-bs-slide="next">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Next</span>
                </button> */}
            </div>
        </div>
        {/* <!-- Carousel End --> */}



        {/* <!-- About Start --> */}
        <div class="container-fluid py-5">
            <div class="container py-5">
                <div class="row g-5">
                    <div class="col-lg-6 col-md-12 wow fadeInUp" data-wow-delay=".3s">
                        <div class="about-img">
                            <div class="rotate-left "></div>
                            <div class="rotate-right "></div>
                            <img src={about} class="img-fluid" alt="img" style={{width: "100%", height: "620px", objectFit:"cover"}}/>
                            <div class="bg-white experiences">
                                <h1 class="display-3">2</h1>
                                <h6 class="fw-bold">Years Of Experiences</h6>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-12 wow fadeInUp" data-wow-delay=".6s">
                        <div class="about-item overflow-hidden">
                            <h5 class="mb-2 px-3 py-1 text-dark rounded-pill d-inline-block border border-2 border-primary">About Care Foundation</h5>
                            <h1 class="display-5 mb-2">Serving Communities Through Care, Health & Education Since 2024</h1>
                            <p class="fs-5" style={{"text-align": "justify"}}>Care Foundation is committed to improving lives through free medical camps, health awareness programs, educational support, and community welfare initiatives. We work to ensure that underserved individuals and families have access to essential healthcare, knowledge, and opportunities for a healthier and brighter future.</p>
                            <div class="row">
                                <div class="col-3">
                                    <div class="text-center">
                                        <div class="p-4  rounded d-flex" style={{"align-items": "center", "justify-content": "center"}}>
                                            <i class="fas fa-heartbeat fa-4x text-primary"></i>
                                        </div>
                                        <div class="my-2">
                                            <h5>Health </h5>
                                            <h5>Awareness</h5>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="text-center">
                                        <div class="p-4  rounded d-flex" style={{"align-items": "center", "justify-content": "center"}}>
                                            <i class="fas fa-graduation-cap fa-4x text-primary"></i>
                                        </div>
                                        <div class="my-2">
                                            <h5>Better</h5>
                                            <h5>Education</h5>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="text-center">
                                        <div class="p-4  rounded d-flex" style={{"align-items": "center", "justify-content": "center"}}>
                                            <i class="fas fa-lightbulb fa-4x text-primary"></i>
                                        </div>
                                        <div class="my-2">
                                            <h5>Bright </h5>
                                            <h5>Furture</h5>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="text-center">
                                        <div class="p-4  rounded d-flex" style={{"align-items" : "center", "justify-content" : "center"}}>
                                            <i class="fas fa-hands-helping fa-4x text-primary"></i>
                                        </div>
                                        <div class="my-2">
                                            <h5>Help </h5>
                                            <h5>Someone</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <button type="button" class="btn btn-primary border-0 rounded-pill px-4 py-3 text-white mt-5">Find Services</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        {/* <!-- About End --> */}


        {/* <!-- Services Start --> */}
        <div class="container-fluid services py-5">
            <div class="container text-center py-5">
                <div class="text-center mb-5 wow fadeInUp" data-wow-delay=".3s">
                    <h5 class="mb-2 px-3 py-1 text-dark rounded-pill d-inline-block border border-2 border-primary">Our Services</h5>
                    <h1 class="display-5">Creating Impact Through Care & Community Support</h1>
                </div>
        <div className="row g-5">

            {/* Health Services */}
            <div className="col-xxl-3 col-lg-6 col-md-6 col-sm-12 wow fadeInUp h-100" data-wow-delay=".3s">
                <div
                    className="bg-light rounded p-5 services-item d-flex flex-column h-100"
                    style={{ alignItems: "center" }}
                >
                    <div
                        className="d-flex"
                        style={{ alignItems: "center", justifyContent: "center" }}
                    >
                        <div className="mb-4 rounded-circle services-inner-icon">
                            <i className="fas fa-notes-medical fa-4x text-primary"></i>
                        </div>
                    </div>

                    <h4 className="text-center">Health Services</h4>

                    <p
                        className="text-center fs-5"
                        style={{ minHeight: "210px" }}
                    >
                        Providing free medical camps, healthcare support, and health
                        checkups for underserved communities.
                    </p>

                    <Link to="/services"
                        type="button"
                        className="btn btn-primary border-0 rounded-pill px-4 py-3 mt-auto text-white"
                    >
                        Learn More
                    </Link>
                </div>
            </div>

            {/* Education Support */}
            <div className="col-xxl-3 col-lg-6 col-md-6 col-sm-12 wow fadeInUp h-100" data-wow-delay=".5s">
                <div
                    className="bg-light rounded p-5 services-item d-flex flex-column h-100"
                    style={{ alignItems: "center" }}
                >
                    <div
                        className="d-flex"
                        style={{ alignItems: "center", justifyContent: "center" }}
                    >
                        <div className="mb-4 rounded-circle services-inner-icon">
                            <i className="fas fa-graduation-cap fa-4x text-primary"></i>
                        </div>
                    </div>

                    <h4 className="text-center">Education Support</h4>

                    <p
                        className="text-center fs-5"
                        style={{ minHeight: "180px" }}
                    >
                        Supporting students through educational programs and academic
                        development initiatives.
                    </p>

                  <Link to="/services"
                        type="button"
                        className="btn btn-primary border-0 rounded-pill px-4 py-3 mt-auto text-white"
                    >
                        Learn More
                    </Link>
                </div>
            </div>

            {/* Community Awareness */}
            <div className="col-xxl-3 col-lg-6 col-md-6 col-sm-12 wow fadeInUp h-100" data-wow-delay=".7s">
                <div
                    className="bg-light rounded p-5 services-item d-flex flex-column h-100"
                    style={{ alignItems: "center" }}
                >
                    <div
                        className="d-flex"
                        style={{ alignItems: "center", justifyContent: "center" }}
                    >
                        <div className="mb-4 rounded-circle services-inner-icon">
                            <i className="fas fa-bullhorn fa-4x text-primary"></i>
                        </div>
                    </div>

                    <h4 className="text-center">Community Awareness</h4>

                    <p
                        className="text-center fs-5"
                        style={{ minHeight: "180px" }}
                    >
                        Promoting health, hygiene, and social awareness through outreach
                        programs and workshops.
                    </p>

                  <Link to="/services"
                        type="button"
                        className="btn btn-primary border-0 rounded-pill px-4 py-3 mt-auto text-white"
                    >
                        Learn More
                    </Link>
                </div>
            </div>

            {/* Community Welfare */}
            <div className="col-xxl-3 col-lg-6 col-md-6 col-sm-12 wow fadeInUp h-100" data-wow-delay=".9s">
                <div
                    className="bg-light rounded p-5 services-item d-flex flex-column h-100"
                    style={{ alignItems: "center" }}
                >
                    <div
                        className="d-flex"
                        style={{ alignItems: "center", justifyContent: "center" }}
                    >
                        <div className="mb-4 rounded-circle services-inner-icon">
                            <i className="fas fa-hand-holding-heart fa-4x text-primary"></i>
                        </div>
                    </div>

                    <h4 className="text-center">Community Welfare</h4>

                    <p
                        className="text-center fs-5"
                        style={{ minHeight: "180px" }}
                    >
                        Helping families in need through welfare projects, charitable
                        support, and community development.
                    </p>

                  <Link to="/services"
                        type="button"
                        className="btn btn-primary border-0 rounded-pill px-4 py-3 mt-auto text-white"
                    >
                        Learn More
                    </Link>
                </div>
            </div>

            </div>
                {/* <button type="button" class="btn btn-primary border-0 rounded-pill px-4 py-3 mt-4 wow fadeInUp" data-wow-delay=".3s">More Services</button> */}
            </div>
        </div>
        {/* <!-- Services End --> */}


        {/* <!-- Project Start --> */}
        <div class="container-fluid py-5">
            <div class="container py-5">
                <div class="text-center mb-5 wow fadeInUp" data-wow-delay=".3s">
                    <h5 class="mb-2 px-3 py-1 text-dark rounded-pill d-inline-block border border-2 border-primary">Our Work</h5>
                    <h1 class="display-5">Serving Communities Through Health, Education & Social Welfare</h1>
                </div>
                <div class="row g-5">
                    <div class="col-xxl-4 col-lg-6 col-md-6 col-sm-12 wow fadeInUp" data-wow-delay=".3s">
                        <div class="project-item">
                            <img src={ourWork1} class="img-fluid h-100" alt="img" />
                            <Link to="events" class="fs-4 fw-bold text-center ">Free Medical Camps</Link>
                        </div>
                    </div>
                    <div class="col-xxl-4 col-lg-6 col-md-6 col-sm-12 wow fadeInUp" data-wow-delay=".5s">
                        <div class="project-item">
                            <img src={ourWork2} alt="img" />
                            <Link to="events" class="fs-4 fw-bold text-center">Education Sittings</Link>
                        </div>
                    </div>
                    <div class="col-xxl-4 col-lg-6 col-md-6 col-sm-12 wow fadeInUp" data-wow-delay=".7s">
                        <div class="project-item">
                            <img src={ourWork3} />
                            <Link to="events" class="fs-4 fw-bold text-center ">Health Awareness</Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        {/* <!-- Project End --> */}


        {/* <!-- Daily Health Tips--> */}
        <div class="container-fluid py-5">
            <div class="container py-5">
                <div class="text-center mb-5 wow fadeInUp" data-wow-delay=".3s">
                    <h5 class="mb-2 px-3 py-1 text-dark rounded-pill d-inline-block border border-2 border-primary">Knowledge Center</h5>
                    <h1 class="display-5">News, Health Tips & Educational Resources</h1>
                </div>
                <div class="owl-carousel blog-carousel wow fadeInUp" data-wow-delay=".5s">
                    <div class="blog-item">
                        <img src={knowledge} class="img-fluid w-100 rounded-top" alt="" />
                    </div>
                    {knowledgeCenters.map((item) => (

                        <div
                            className="blog-item"
                            key={item.id}
                        >

                            <div className="rounded-bottom bg-light mt-2">

                                <div className="p-3">

                                    <div className="d-flex justify-content-between align-items-start">

                                        <h4 className="mb-0">
                                            {item.title}
                                        </h4>

                                        <small className="text-muted ms-3">
                                            {new Date(item.created_at).toLocaleDateString(
                                                "en-US",
                                                {
                                                    day: "numeric",
                                                    month: "short",
                                                    year: "numeric",
                                                }
                                            )}
                                        </small>

                                    </div>

                                </div>

                                <div
                                    className="p-1 bg-primary rounded-bottom"
                                >

                                    <a
                                        href={item.url}
                                        target="_blank"
                                        rel="noreferrer"
                                        className="btn btn-primary  border-0 rounded-pill px-4 py-1 mt-auto text-white"
                                    >
                                        View
                                    </a>

                                </div>

                            </div>
                           </div>
                        
                    ))}
                    <Link
                        to="/knowledge-center"
                        className="btn btn-outline-primary mt-4"
                    >
                        View All
                    </Link>
                </div>
            </div>
        </div>
        {/* <!-- Blog End --> */}


        {/* <!-- Call To Action Start --> */}
        <div class="container-fluid py-5 call-to-action wow fadeInUp" data-wow-delay=".3s" style={{"margin": "6rem 0"}}>
            <div class="container">
                <div class="row g-4">
                    <div class="col-lg-6">
                        {/* <img src={updates} class="img-fluid w-100 rounded-circle p-5" alt="" /> */}
                    </div>
                    <div class="col-lg-6 my-auto">
                        <div class="text-start mt-4">
                            <h1 class="pb-4 text-white">Sign Up To Our Newsletter To Keep Updated</h1>
                        </div>
                        <form method="post" action="index.html">
                            <div class="form-group">
                                <div class="d-flex call-btn">
                                    <input type="search" class="form-control py-3 px-4 w-100 border-0 rounded-0 rounded-end rounded-pill" name="search-input" value="" placeholder="Enter Your Email Address" required="Please enter a valid email"/>
                                    <button type="email" value="Search Now!" class="btn btn-primary border-0 rounded-pill text-white rounded rounded-start px-5">Subscribe</button>
                                </div>
                            </div>
                        </form>  
                    </div>
                </div> 
            </div>
        </div>
        {/* <!-- Call To Action End --> */}



        {/* <!-- Team Start --> */}
        <Team />
        {/* <!-- Team End --> */}

        </div>
    )
}